import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M30.88 11.827a1.937 1.937 0 0 0-1.81-1.251h-7.838a.644.644 0 0 1-.608-.426l-2.813-7.906A1.931 1.931 0 0 0 16.002 1a1.93 1.93 0 0 0-1.81 1.244l-.005.02-2.807 7.886a.644.644 0 0 1-.607.426h-7.84a1.93 1.93 0 0 0-1.817 1.261 1.904 1.904 0 0 0 .577 2.123l6.675 5.489a.635.635 0 0 1 .2.693L5.762 28.48a1.905 1.905 0 0 0 .695 2.153c.68.49 1.601.49 2.28-.003l6.883-5.004a.648.648 0 0 1 .76 0l6.882 5.002c.678.495 1.6.498 2.281.006.68-.49.962-1.363.695-2.154l-2.804-8.342a.635.635 0 0 1 .2-.693l6.688-5.497a1.904 1.904 0 0 0 .557-2.12Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }